import { NgModule } from '@angular/core';
import { AppSwitcherComponent } from './app-switcher.component';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
@NgModule({
  declarations: [AppSwitcherComponent],
  exports: [AppSwitcherComponent],
  imports: [CommonModule, MatMenuModule],
})
export class AppSwitcherModule {}